<template>
  <v-container class="pa-0" fluid>
    <v-dialog v-model="dMostrarAviso" persistent max-width="400px">
      <v-card class="data-aviso">
        <v-card-title class="subheading">
          <v-flex xs12>
            <v-icon large class="accent--text">error_outline</v-icon>
          </v-flex>
          <v-flex xs12 mb-3 class="text-xs-center">
            <span v-html="dTextAviso"></span>
          </v-flex>
        </v-card-title>
        <v-card-actions pt-4>
          <v-spacer></v-spacer>
          <v-btn class="datPrimaryBtn" @click="dMostrarAviso = false">{{ this.$t('cerrar') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dOpenComponente" v-model="dLoadingPED" hide-overlay persistent width="300">
      <v-card class="datModalTitleContainer" dark>
        <v-card-text>
          {{ $t('cargandoContenido') }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dOpenFechaDefault" v-model="dLoadingDefault" hide-overlay persistent width="400">
      <v-card class="datModalTitleContainer" dark>
        <v-card-text>
          {{ $t('cargandoFechaDefecto') + dDiasAnteriores + $t('cargandoFechaDefectoAnterior') }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dOpenComponente" content-class="" persistent>
      <v-card class="pa-0 ma-0">
        <v-toolbar dark class="datModalTitleContainer">
          <v-toolbar-title>
            {{ dInformeComponente.nombre }}
            <span v-if="dSelectedClient && dSelectedClient.clienteNombre"> {{ $t('de') }}
              {{ dSelectedClient.clienteNombre }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="fCerrarVentana()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-layout row wrap align-top class="pa-3" justify-end>
          <v-flex xs12 class="top-actions">
            <v-btn small class="datSecondaryBtn top-action-btn" flat @click="fBuscarPedidos()"
              :disabled="!dDatosFecha.fechasValidas">
              <span>{{ $t('buscar') }}</span>
              <v-tooltip bottom>
                <span>{{ $t('aplicarFiltrosYcomenzar') }}</span>
                <v-icon small right slot="activator">mdi-magnify</v-icon>
              </v-tooltip>
            </v-btn>
            <v-btn small @click="dShowFilters = !dShowFilters" flat tile class="datSecondaryBtn top-action-btn">
              <span>{{ $t('advancedFilters') }}</span>
              <v-icon small right v-if="dShowFilters === false">mdi-filter-plus</v-icon>
              <v-icon small right v-else>mdi-filter-minus</v-icon>
            </v-btn>
            <v-btn small class="datSecondaryBtnOut top-action-btn" flat @click="fLimpiaFiltros(false)">
              <span>{{ $t('limpiarFiltros') }}</span>
              <v-icon small right>mdi-filter-remove-outline</v-icon>
            </v-btn>
            <!-- Seccion de botones -->
            <v-menu offset-y left class="top-action-menu">
              <v-btn slot="activator" small flat class="datSecondaryBtn top-action-menu-btn">
                <span>{{ $t('acciones') }}</span>
                <v-icon small right>mdi-dots-vertical</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile v-if="dRole !== 'CLIENTE' && dRole !== 'SUCURSAL' && dRole !== 'MULTISUCURSAL'"
                  @click="fOpenClientDialog">
                  <v-list-tile-avatar class="mr-2">
                    <v-icon small>mdi-account-search</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-title>{{ $t('filtrarClientes') }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="fDescargarCsvPedidos()" :disabled="!dDatosFecha.fechasValidas">
                  <v-list-tile-avatar class="mr-2">
                    <v-icon small>mdi-file-download-outline</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-title>{{ $t('descargar') }} CSV</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
        <v-slide-y-transition>
          <v-layout v-show="dShowFilters" row wrap align-top class="px-3 pb-3" justify-space-between>
            <v-flex xs12 md3 pr-3 v-if="dRole !== 'CLIENTE' && dRole !== 'MULTISUCURSAL' && dRole !== 'SUCURSAL'">
              <v-layout row wrap align-center>
                <v-flex xs11>
                  <DatTextFieldCode ref="TablaDeClientes" :pDataPass="dDataClient" @alert="fAlert"
                    @select="fSelectClient" @clean="fClearClient"></DatTextFieldCode>
                </v-flex>
                <v-flex xs1>
                  <v-tooltip top>
                    <v-btn slot="activator" flat small icon @click="dShowClientSearch = !dShowClientSearch"
                      class="datSecondaryBtn">
                      <v-icon small v-if="dShowClientSearch === false">mdi-filter-plus-outline</v-icon>
                      <v-icon small v-else>mdi-filter-minus-outline</v-icon>
                    </v-btn>
                    <span>{{ $t('filtroAvzClte') }}</span>
                  </v-tooltip>
                </v-flex>
                <v-slide-y-transition>
                  <v-flex xs11>
                    <v-card-text class="pa-0 ma-0" v-show="dShowClientSearch">
                      <v-layout row wrap>
                        <DatTextFieldCode v-if="dRole !== 'SUCURSAL' && !dIsOnPremise" ref="TablaDeSucursal"
                          :pDataPass="dDataSucursal" @select="fSelectSucursal" @clean="fClearSucursal">
                        </DatTextFieldCode>
                        <v-flex>
                          <v-autocomplete v-model="dZonaCliente" :items="dZonaItems" attach :label="$t('zonaDesc')"
                            item-value="zona" item-text="nombre" clearable></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-flex>
                </v-slide-y-transition>
              </v-layout>
            </v-flex>
            <v-flex v-else>
              <template v-if="dRole !== 'SUCURSAL'">
                <v-flex v-if="dRole !== 'CLIENTE' && dRole !== 'MULTISUCURSAL'" md5 pr-3>
                  <DatTextFieldCode ref="TablaDeClientes" :pDataPass="dDataClient" @select="fSelectClient"
                    @clean="fCleanClient" @alert="fAlert"></DatTextFieldCode>
                </v-flex>
                <v-flex :md="(dRole === 'CLIENTE' || dRole === 'MULTISUCURSAL') ? 12 : 5" pr-3>
                  <DatTextFieldCode v-if="!dIsOnPremise" ref="TablaDeSucursal" :pDataPass="dDataSucursal"
                    @select="fSelectSucursal" @clean="fClearSucursal" @alert="fAlert"></DatTextFieldCode>
                </v-flex>
              </template>
            </v-flex>
            <v-flex xs12 md3 pr-3 v-if="fComprobacionRepresentante()">
              <v-flex class="text-xs-center">
                <DatTextFieldCodeSubfield ref="TablaDeRepresentantes" :pDataPass="dDataRepre" @select="fSelectRepre"
                  @alert="fAlert" @clean="fClearRepre"></DatTextFieldCodeSubfield>
              </v-flex>
            </v-flex>

            <v-flex xs12 md2 pr-3>
              <v-layout row wrap align-center>
                <v-flex xs11 md11>
                  <v-text-field class="" v-model="dSuReferencia" :label="this.$t('suReferenciaDesc')"></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-tooltip top>
                    <v-btn slot="activator" flat small icon @click="dShowOrderState = !dShowOrderState"
                      class="datSecondaryBtn">
                      <v-icon small v-if="dShowOrderState === false">mdi-filter-plus-outline</v-icon>
                      <v-icon small v-else>mdi-filter-minus-outline</v-icon>
                    </v-btn>
                    <span>{{ $t('filtroAvzPed') }}</span>
                  </v-tooltip>
                </v-flex>
                <v-slide-y-transition>
                  <v-flex xs11>
                    <v-card-text class="pa-0 ma-0" v-show="dShowOrderState">
                      <v-layout row wrap align-center>
                        <v-flex xs12>
                          <v-select v-model="dPedidosValue" :items="dPedidoItems" item-text="name" item-value="id"
                            attach small-chips clearable :label="$t('estadoPedido')" multiple>
                          </v-select>
                        </v-flex>
                        <v-flex xs12 pr-1>
                          <p class="datLabelGroup">
                            {{ $t('fechaPedido') }}
                          </p>
                          <v-menu ref="dInicialMenu" v-model="dInicialMenu" lazy transition="scale-transition" offset-y
                            full-width :nudge-right="40" min-width="290px" :close-on-content-click="false">
                            <v-text-field clearable v-model="dDatosFecha.inicialString" required color="data-colorcorp1"
                              slot="activator" :label="$t('fechaInicial')" append-icon="event" readonly
                              :rules="[rules.checkfechas]"></v-text-field>
                            <v-date-picker :min="dDatosFecha.minIni" v-model="dFechaInicialDate" no-title scrollable
                              :first-day-of-week="1" locale="es-es" @input="$refs.dInicialMenu.save(dFechaInicialDate)">
                            </v-date-picker>
                          </v-menu>
                          <v-menu ref="dFinalMenu" v-model="dFinalMenu" lazy transition="scale-transition" offset-y
                            full-width :nudge-right="40" min-width="290px" :close-on-content-click="false">
                            <v-text-field clearable v-model="dDatosFecha.finalString" required color="data-colorcorp1"
                              slot="activator" :label="$t('fechaFinal')" append-icon="event" readonly
                              :rules="[rules.checkfechas]"></v-text-field>
                            <v-date-picker :min="dDatosFecha.minFin" v-model="dFechaFinalDate" no-title scrollable
                              :first-day-of-week="1" locale="es-es" @input="$refs.dFinalMenu.save(dFechaFinalDate)">
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model="dNumeroPedido" :label="this.$t('numeroPedido')"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model="dArticulo" clearable :label="this.$t('articulo')"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field v-model="dObra" clearable :label="this.$t('obra')"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-flex>
                </v-slide-y-transition>
              </v-layout>

            </v-flex>
            <v-flex xs12 md4 pl-3 class="filtros-pedidos-chips-col">
              <v-layout row wrap class="filtros-pedidos-chips-wrap">
                <v-chip v-for="item in dFiltrosPedidos" :key="item.tipo" small class="ma-1" :outline="!item.selected"
                  :class="['filtros-pedidos-chip', item.selected ? 'secondaryColorBackground white--text' : '']"
                  @click="item.selected = !item.selected">
                  <v-icon left small>{{ item.selected ? 'mdi-check' : 'mdi-plus' }}</v-icon>
                  {{ item.text }}
                </v-chip>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-slide-y-transition>

        <div class="pa-0" v-if="dShowClient === true">
          <v-layout row wrap class="pl-3">
            <v-flex xs12 md4 class="pr-3 pt-3">
              <v-text-field class="labelText" placeholder="Selecciona un cliente de la tabla pulsando el botón"
                label="Cliente seleccionado en tabla" v-model="dSelectedClient.clienteNombre" readonly></v-text-field>
            </v-flex>
            <v-flex shrink class="my-auto">
              <v-btn small class="datPrimaryBtnOut pa-2" text flat @click.stop="dClientSearchDialog = true">
                <v-icon>mdi-account-search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
        <v-card>
          <v-card-text class="pa-0">
            <v-data-table item-key="rn" :headers="dHeadersPED" :items="dPedidos" :no-data-text="this.$t('noResultados')"
              :no-results-text="this.$t('noResultados')" v-bind:pagination.sync="dPaginationPED" :loading="dLoadingPED"
              :total-items="dTotalItemsPED" class="fixed-table tablePedidos" @click="fChangeSort(item.value)"
              :expand="dExpand" :rows-per-page-text="this.$t('numPedidosPagina')"
              :rows-per-page-items="dRowsPerPageItemsPED">
              <template slot="headers" slot-scope="props">
                <tr class="lightPrimaryColorBackground">
                  <th v-for="header in props.headers" :key="header.value" :id="header.value"
                    :class="['column', (header.sortable) ? 'sortable' : '', dPaginationPED.descending ? 'desc' : 'asc', header.value === dPaginationPED.sortBy ? 'active' : header.class, 'text-xs-' + header.align + ' ' + header.class + ' ']"
                    @click="fCambiaOrden(header.value)">
                    <v-icon v-if="header.sortable">arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <tr :class="props.expanded ? 'selectedRow' : ''">
                  <td class="text-xs-center pr-0 pl-2" :id="props.item.clteCodigo" :style="{ width: '40px' }"
                    @click="fExpand(props)">
                    <v-icon :class="props.expanded ? 'iconRotate cursorPointer' : 'cursorPointer'">
                      arrow_downward
                    </v-icon>
                  </td>
                  <td class="text-xs-center pr-0 pl-2" :style="{ width: '20px' }">
                    <v-icon small :color="fGetColor(props.item.estadoPedidoRetenido)"
                      :title="fGetDenominacionColor(props.item.estadoPedidoRetenido)">
                      mdi-checkbox-blank-circle
                    </v-icon>
                  </td>
                  <td class="text-xs-left pr-2 largeWidthEllipsis">
                    <v-icon small class="datSecondaryColor cursorPointer"
                      @click="fGetCliente(props.item.clteCodigo, props.item.clteEmpresa)">mdi-account</v-icon>
                    <v-tooltip top>
                      <span>{{ props.item.clteCodigo }}</span>
                      <span slot="activator" class="cursorPointer boldLabelOnTable">{{ props.item.clteNombre }}</span>
                    </v-tooltip>
                  </td>
                  <td class="text-xs-left pl-3 pr-1 xtraLargeWidthEllipsis">
                    <v-tooltip top>
                      <span slot="activator" class="fontTable cursorPointer ellipsis">{{ props.item.razonSocial
                        }}</span>
                      <span>{{ props.item.razonSocial }}</span>
                    </v-tooltip>
                  </td>
                  <td class="text-xs-left pl-3 pr-1 xtraLargeWidthEllipsis">
                    <v-tooltip top>
                      <span slot="activator" class="fontTable cursorPointer ellipsis">{{
                        dTiposPedidos[props.item.pedido_cargo_abono] }}</span>
                      <span>{{ props.item.pedido_cargo_abono }}</span>
                    </v-tooltip>
                  </td>
                  <td class="text-xs-right smallWidthEllipsis">
                    <v-tooltip top>
                      <span slot="activator" class="cursorPointer boldTextOnModalAlt fontTable">{{
                        props.item.cpmNumPedido }}</span>
                      <span>{{ props.item.clteNombre }}</span>
                    </v-tooltip>
                    <v-icon class="pr-1 cursorPointer datSecondaryColor" :id="'pedido_' + props.item.clteCodigo"
                      @click="fGetPedido(props.item)">
                      info
                    </v-icon>
                  </td>
                  <td class='text-xs-right smallWidthEllipsis'>
                    <v-tooltip top>
                      <span slot="activator" class="fontTable cursorPointer">{{ props.item.fechaPedidoFormat }} </span>
                      <span>{{ props.item.clteNombre }}</span>
                    </v-tooltip>
                  </td>
                  <td class='text-xs-right smallWidthEllipsis'>
                    <v-tooltip top>
                      <span slot="activator" class="fontTable cursorPointer">{{ props.item.cpmNumPedidoWeb }} </span>
                      <span>{{ props.item.cpmNumPedidoWeb }}</span>
                    </v-tooltip>
                  </td>
                  <td class='text-xs-left pl-3 pr-1 smallWidthEllipsis'>
                    <v-tooltip top>
                      <span slot="activator" class="fontTable cursorPointer">{{ props.item.obra }} </span>
                      <span>{{ props.item.obra }}</span>
                    </v-tooltip>
                  </td>
                  <td class="text-xs-left pl-3 pr-1 xtraLargeWidthEllipsis"
                    v-if="dHeaderDomain === 'CHAVES' || dHeaderDomain === 'CHAVESPR'">
                    <v-tooltip top>
                      <span slot="activator" class="fontTable cursorPointer ellipsis">{{ props.item.refLineal }}</span>
                      <span>{{ props.item.refLineal }}</span>
                    </v-tooltip>
                  </td>
                  <td class="text-xs-left pl-3 pr-1 xtraLargeWidthEllipsis" v-else>
                    <v-tooltip top>
                      <span slot="activator" class="fontTable cursorPointer ellipsis">{{ props.item.refPedido }}</span>
                      <span>{{ props.item.refPedido }}</span>
                    </v-tooltip>
                  </td>
                  <td class="text-xs-left statusInfo">
                    <span class="">
                      <template v-for="items in loadAllOrderWebStatusSync()">
                        <v-icon v-if="getStatusWebCode(props.item.situacionPedido) > items.id"
                          :key="items.id">mdi-checkbox-blank-circle </v-icon>
                        <v-icon v-if="getStatusWebCode(props.item.situacionPedido) === items.id" :key="items.id">
                          mdi-check-circle</v-icon>
                        <v-icon v-if="getStatusWebCode(props.item.situacionPedido) < items.id" :key="items.id">
                          mdi-checkbox-blank-circle-outline</v-icon>
                      </template>
                    </span>
                    <p class="mb-0">{{ getStatusWebDescripcion(props.item.situacionPedido) }}</p>
                  </td>
                  <td class="text-xs-left smallWidthEllipsis pl-1" style="vertical-align: middle">
                    <v-tooltip top>
                      <v-layout v-if="props.item.mostrarBtn" @click="fOpenModalEstados(props.item, 'pedido')"
                        slot="activator" class="" style="max-width: 100%" text-color="white">
                        <v-flex class="text-truncate chip-fake">
                          <v-icon left small class="mr-2">mdi-truck</v-icon>{{ $t('consultaPelikane') }}
                        </v-flex>
                      </v-layout>
                      <span>Último estado del pedido</span>
                    </v-tooltip>
                  </td>
                  <td class="text-xs-left smallWidthEllipsis pl-1">
                    <v-tooltip top>
                      <span slot="activator" class="fontTable">{{ props.item.agenciaTransporte }}</span>
                      <span>{{ props.item.agenciaTransporte }}</span>
                    </v-tooltip>
                  </td>
                  <template v-if="dHeaderDomain !== 'CHAVES' && dHeaderDomain !== 'CHAVESPR'">

                    <td
                      :class="['text-xs-right pr-3 smallWidthEllipsis', fComprobarFechaEntrega(props.item.fechaEntrega, props.item.situacionPedido)]">
                      <v-tooltip top>
                        <span slot="activator" class="fontTable">{{ fGetLineDeliveryDate(props.item) |
                          moment(dFormatDate.default) }} </span>
                        <span>{{ fGetLineDeliveryDate(props.item) | moment(dFormatDate.default) }}</span>
                      </v-tooltip>
                    </td>
                  </template>
                </tr>
              </template>
              <template slot="expand" slot-scope="props">
                <template v-if="dHeaderDomain === 'CHAVES' || dHeaderDomain === 'CHAVESPR'">
                  <thead class="lighterPrimaryColorBackground">
                    <tr class="px-2">
                      <th id="flecha" style="width: 50px;" class="subHeaderTextInTable text-xs-center px-3"></th>
                      <th id="articulo" style="width: 250px;" class="subHeaderTextInTable text-xs-center pl-3">{{
                        $t('articulo') }}</th>
                      <th id="denominacion" style="width: 900px;" class="subHeaderTextInTable text-xs-center">{{
                        $t('denominacion') }}</th>
                      <th id="cantidad" style="width: 100px;" class="subHeaderTextInTable text-xs-center">{{
                        $t('cantidad') }}</th>
                      <th id="refLineal" style="width: 150px;" class="subHeaderTextInTable text-xs-center pr-3">{{
                        $t('suReferencia') }}</th>
                      <th id="estado" style="width: 500px;" class="subHeaderTextInTable text-xs-center px-3">{{
                        $t('estado') }}</th>
                      <th id="estadoPedido" style="width: 260px;" class="subHeaderTextInTable text-xs-center px-3">{{
                        $t('estadoPedido') }}</th>
                      <th id="agenciaTte" style="width: 250px;" class="subHeaderTextInTable text-xs-center px-3">{{
                        $t('agenciaTte') }}</th>
                      <th id="fechaIni" style="width: 100px;" class="subHeaderTextInTable text-xs-center pr-3">{{
                        $t('fechaInici') }}</th>
                      <th id="fechaFin" style="width: 100px;" class="subHeaderTextInTable text-xs-center pr-3">{{
                        $t('fechaFinal') }}</th>
                    </tr>
                  </thead>
                </template>
                <template v-else>
                  <thead class="lighterPrimaryColorBackground">
                    <tr class="px-2">
                      <th id="flecha" style="width: 50px;" class="subHeaderTextInTable text-xs-center px-3"></th>
                      <th id="articulo" style="width: 250px;" class="subHeaderTextInTable text-xs-center pl-3">{{
                        $t('articulo') }}</th>
                      <th id="denominacion" style="width: 900px;" class="subHeaderTextInTable text-xs-center">{{
                        $t('denominacion') }}</th>
                      <th id="cantidad" style="width: 100px;" class="subHeaderTextInTable text-xs-center">{{
                        $t('cantidad') }}</th>
                      <th id="estado" style="width: 500px;" class="subHeaderTextInTable text-xs-center px-3">{{
                        $t('estado') }}</th>
                      <th id="estadoPedido" style="width: 260px;" class="subHeaderTextInTable text-xs-center px-3">{{
                        $t('estadoPedido') }}</th>
                      <th id="agenciaTte" style="width: 250px;" class="subHeaderTextInTable text-xs-center px-3">{{
                        $t('agenciaTte') }}</th>
                      <th id="fechaExpedicion" style="width: 100px;" class="subHeaderTextInTable text-xs-center pr-3">{{
                        $t('fechaExpedicion') }}</th>
                    </tr>
                  </thead>
                </template>
                <tr v-for="(linea) in dLineasPedido" :key="linea.articulo"
                  :class="[props.expanded ? 'selectedRow' : '']">
                  <td class="text-xs-center pr-0 pl-2" style="width: 20px;vertical-align:middle">
                    <v-icon small :color="fGetColorLinea(linea.estadoPedido)">
                      mdi-checkbox-blank-circle
                    </v-icon>
                  </td>
                  <td class="text-xs-center px-3 mediumWidthEllipsis">
                    <v-tooltip top>
                      <span slot="activator" class="fontTable">{{ linea.articulo }}</span>
                      <span>{{ linea.articulo }}</span>
                    </v-tooltip>
                  </td>
                  <td class="text-xs-center largeWidthEllipsis">
                    <v-tooltip top>
                      <span slot="activator" class="text-xs-center fontTable">{{ linea.articuloNombre }}</span>
                      <span>{{ linea.articuloNombre }}</span>
                    </v-tooltip>
                  </td>
                  <td class="text-xs-center fontTable smallWidthEllipsis">{{ fFormatNumber(linea.cantidad) }}</td>
                  <template v-if="dHeaderDomain === 'CHAVES' || dHeaderDomain === 'CHAVESPR'">
                    <td class="text-xs-center fontTable smallWidthEllipsis">{{ linea.referenciaLineal }}</td>
                  </template>
                  <td class="text-xs-center statusInfo" style="vertical-align: middle">
                    <span>
                      <template v-for="items in loadAllOrderWebStatusSync()">
                        <v-icon v-if="getStatusWebCode(linea.estadoWeb) > items.id"
                          :key="items.id">mdi-checkbox-blank-circle</v-icon>
                        <v-icon v-if="getStatusWebCode(linea.estadoWeb) === items.id" :key="items.id">
                          mdi-check-circle</v-icon>
                        <v-icon v-if="getStatusWebCode(linea.estadoWeb) < items.id" :key="items.id">
                          mdi-checkbox-blank-circle-outline</v-icon>
                      </template>
                    </span>
                    <p class="mb-0">{{ getStatusWebDescripcion(linea.estadoWeb) }}</p>
                  </td>
                  <td class="text-xs-center smallWidthEllipsis pl-1" style="vertical-align: middle">
                    <v-tooltip top>
                      <v-layout v-if="linea.mostrar" @click="fOpenModalEstados(linea, 'linea')" slot="activator"
                        class="" style="max-width: 100%" text-color="white">
                        <v-flex class="text-truncate chip-fake">
                          <v-icon left small class="mr-2">mdi-truck</v-icon>
                          {{ linea.ultimoEstado }}
                        </v-flex>
                      </v-layout>
                      <span>Último estado del pedido</span>
                    </v-tooltip>
                  </td>
                  <td class="text-xs-center smallWidthEllipsis pl-1">
                    <v-tooltip top>
                      <span slot="activator" class="fontTable">{{ props.item.agenciaTransporte }}</span>
                      <span>{{ props.item.agenciaTransporte }}</span>
                    </v-tooltip>
                  </td>
                  <template v-if="dHeaderDomain === 'CHAVES' || dHeaderDomain === 'CHAVESPR'">
                    <td class="text-xs-center px-3 fontTable" style="width: 80px;">{{ linea.fechaInicio |
                      moment(dFormatDate.default) }}</td>
                    <td class="text-xs-center px-3 fontTable" style="width: 80px;">{{ linea.fechaFin |
                      moment(dFormatDate.default) }}</td>
                  </template>
                  <template v-else>
                    <td class="text-xs-center px-3 fontTable" style="width: 80px;">{{ linea.fechaSituacion |
                      moment(dFormatDate.default) }}</td>
                  </template>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dMostrarErrorDescarga" persistent max-width="400px">
      <v-card class="data-aviso">
        <v-card-title class="subheading">
          <v-flex xs12>
            <v-icon large class="accent--text">error_outline</v-icon>
          </v-flex>
          <v-flex xs12 mb-3 class="text-xs-center">
            <span v-html="dTextoAvisoError"></span>
          </v-flex>
        </v-card-title>
        <v-card-actions pt-4>
          <v-spacer></v-spacer>
          <v-btn class="datPrimaryBtn" @click="dMostrarErrorDescarga = false">{{ this.$t('cancelar') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dMostrarPopupEmailCsv" persistent max-width="480px">
      <v-card>
        <v-card-title class="headline">{{ $t('descargar') }} CSV</v-card-title>
        <v-card-text>
          <v-text-field v-model="dEmailDestinoCsv" label="Email" type="email"
            @keyup.enter="fConfirmarDescargarCsvPedidos" clearable></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="fCancelarPopupEmailCsv">{{ $t('cancelar') }}</v-btn>
          <v-btn class="datPrimaryBtn" @click="fConfirmarDescargarCsvPedidos">{{ $t('enviar') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dClientSearchDialog" max-width="800px">
      <ShpClientSearch @alert="fAlert" @close="fCloseSearchClient" @select="fSeleccionaCliente"></ShpClientSearch>
    </v-dialog>
    <v-dialog v-model="dClientInfoDialog" max-width="600px">
      <v-card flat>
        <v-toolbar dark class="secondaryColorBackground">
          <v-toolbar-title>{{ this.$t('dialogInfoCliente') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dClientInfoDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-list dense class="py-0 px-2">
            <v-list-tile class="condensedRow altRow">
              <v-list-tile-content class="pb-1">{{ $t('codigo') }}:</v-list-tile-content>
              <v-list-tile-content class="pb-1 align-end">{{ dDatosClientes.codigo }}</v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="condensedRow">
              <v-list-tile-content class="pb-1">{{ $t('nombre') }}:</v-list-tile-content>
              <v-list-tile-content class="pb-1 align-end">{{ dDatosClientes.nombre }}</v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="condensedRow altRow">
              <v-list-tile-content class="pb-1">{{ $t('razonSocial') }}:</v-list-tile-content>
              <v-list-tile-content class="pb-1 align-end">{{ dPedidosDetalles.razonSocial }}</v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="condensedRow ">
              <v-list-tile-content class="pb-1">{{ $t('direccion') }}:</v-list-tile-content>
              <v-list-tile-content class="pb-1 align-end">{{ dDatosClientes.direccion }}</v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="condensedRow altRow">
              <v-list-tile-content class="pb-1">{{ $t('poblacion') }}:</v-list-tile-content>
              <v-list-tile-content class="pb-1 align-end">{{ dPedidosDetalles.poblacionEnvio }}</v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="condensedRow">
              <v-list-tile-content class="pb-1">{{ $t('telefono') }}:</v-list-tile-content>
              <v-list-tile-content class="pb-1 align-end">
                <v-layout row wrap class="pa-0">
                  <v-flex shrink class="pa-0">
                    <span class="boldTextOnModal">{{ dPedidosDetalles.telefonoFacturacion }}</span>
                  </v-flex>
                  <v-flex shrink class="py-0 pl-2">
                    <span>
                      <v-icon small @click="fDial(dPedidosDetalles.telefonoFacturacion)"
                        class="datSecondaryColor">call</v-icon>
                    </span>
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile class="condensedRowNoborder altRow">
              <v-list-tile-content class="pb-1">{{ $t('email') }}:</v-list-tile-content>
              <v-list-tile-content class="pb-1 align-end">
                <v-layout row wrap>
                  <v-flex shrink class="pa-0">
                    <span>
                      {{ dDatosClientes.email }}
                    </span>
                  </v-flex>
                  <v-flex shrink class="py-0 pl-2">
                    <span>
                      <v-icon small @click="fSendmail(dDatosClientes.email)" class="datSecondaryColor">mail</v-icon>
                    </span>
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ShpPedidosDetalle ref="PedidosDetalles" v-model="dMostrarPedidosDetalle" :pModelDialog="dMostrarPedidosDetalle"
      :pParamsPedidos="paramsPedidos" :pPedidoDetalle="dPedidosDetalles" :pDatosClientes="dDatosClientes"
      :pScreenWidth="dScreenWidth" @close="fClosePedidosDetalles" @alert="fAlert" :pLimitDate="pLimitDate">
    </ShpPedidosDetalle>

    <ShpStates :pDialog="dDialog" :pBultosPelikane="dBultosPelikane" :pEstadosPelikane="dEstadosPelikane"
      :pUrlTracking="dUrlTracking" :pCodTracking="dCodTracking" :pError="dError" @cerrar="fCerrarModal()"></ShpStates>
  </v-container>
</template>

<script>

// UTILIDADES
import { generarPdf, abrirPestanaEnBlanco, abrirPdfEnPestanaPreabierta } from '@/utils/utilDescargarPdf'

// SERVICIOS
import ServiceRecogidasEntregas from '@/services/srv-recogidas-entregas'
import ServicePelikane from '@/services/srv-pelikane'
import SrvImpresion from '@/services/srv-impresion'
import SrvGeneral from '@/services/srv-general'

// COMPONENTES GENERICOS
import DatTextFieldCode from '@/components_datadec/DatTextFieldCode'
import DatTextFieldCodeSubfield from '@/components_datadec/DatTextFieldCodeSubfield'

// COMPONENTES
import ShpStates from '@/components/Pelikane/ShpStates'
import ShpClientSearch from '@/components/Informes/Pedidos/ShpClientSearch'
import ShpPedidosDetalle from '@/components/Informes/Pedidos/ShpPedidosDetalle'

export default {
  name: 'ShpFiltroReportEstadoPedidos',
  components: {
    ShpStates,
    DatTextFieldCode,
    DatTextFieldCodeSubfield,
    ShpClientSearch,
    ShpPedidosDetalle
  },
  props: {
    pInformeComponente: {
      type: Object,
      required: true
    },
    paramsPedidos: {
      type: Object,
      required: false,
      default: null
    },
    pLimitDate: {
      type: Object,
      required: false,
      default: {}
    }
  },
  data() {
    return {
      // OTROS
      dEventos: {
        'mostrarAviso': 'evento-mostrarAvisos'
      },
      dClass: this.dClass,
      dFormatDate: {
        'default': 'DD/MM/YYYY',
        'years': 'YYYY-MM-DD'
      },
      dContador: 0,
      dDialog: false,

      dSearchArt: '',
      dShowFilters: false,
      dExpand: false,
      dShowOrderState: false,
      dScreenWidth: 0,
      dIsLimpiar: false,
      dProvinciaValue: null,
      dZonaCliente: null,
      dZonaItems: [],
      color: ['#388881'],
      dIsOnPremise: localStorage.getItem('isOnPremise') === 'yes',
      dVisibleBtn: false,
      dSuReferencia: '',
      dDias: 30,
      dOpenFechaDefault: false,
      dDiasAnteriores: 0,
      rowsPerPage: 10,
      dNumValidacionesValue: 0,
      dInterval: {},
      dDescargando: false,
      dDescargarTxt: this.$t('descargar'),
      dChkPresupuesto: false,
      dRole: '',
      dOpenComponente: true,
      dInformeComponente: null,
      dOpenModalState: false,
      dCodTracking: { "codTracking": "", "tipoTracking": "" },
      dError: { "code": "", "message": "" },
      dEstadosPelikane: [],
      dBultosPelikane: [],
      dUrlTracking: '',
      dWindowFactura: null,
      dLoadingDefault: false,

      // HEADERS
      dHeadersArt: [
        { text: 'Código', align: 'right', value: 'artId', sortable: false },
        { text: 'Descripción', align: 'left', value: 'artName', sortable: false }
      ],
      dHeadersPED: [
        { text: '', align: 'center', value: 'iconEstado', sortable: false, class: 'px-0', width: '10px', fixed: true },
        { text: '', align: 'left', value: 'sort', sortable: false, class: 'px-0', width: '10px', fixed: true },
        { text: this.$t('cliente'), align: 'left', value: 'clteNombre', sortable: true, class: 'pl-0 headerTextInTable', width: '300px' },
        { text: this.$t('sucursal'), align: 'left', value: 'razonSocial', sortable: true, class: this.dClass, width: '500px' },
        { text: this.$t('tipoPed'), align: 'left', value: 'pedido_cargo_abono', sortable: true, class: this.dClass, width: '100px' },
        { text: this.$t('pedido'), align: 'right', value: 'cpmNumPedido', sortable: true, class: this.dClass, width: '100px' },
        { text: this.$t('fechaAsignada'), align: 'right', value: 'fechaPedido', sortable: true, class: this.dClass, width: '80px' },
        { text: this.$t('pedidoWeb'), align: 'left', value: 'cpmNumPedidoWeb', sortable: true, class: this.dClass, width: '100px' },
        { text: this.$t('obra'), align: 'left', value: 'obra', sortable: true, class: this.dClass, width: '200px' },
        { text: this.$t('suReferencia'), align: 'left', value: 'refPedido', sortable: true, class: 'pl-3 pr-2 headerTextInTable', width: '350px' },
        { text: this.$t('estado'), align: 'left', value: 'situacionPedido', sortable: true, class: this.dClass, width: '100px' },
        { text: this.$t('estadoPedido'), align: 'left', value: 'estadoPelikane', sortable: true, class: this.dClass, width: '150px' },
        { text: this.$t('agenciaTte'), align: 'left', value: 'agenciaTransporte', sortable: true, class: this.dClass, width: '100px' },
        { text: this.$t('fechaExpedicion'), align: 'right', value: 'fechaRecepPedido', sortable: true, class: 'pl-1 pr-3 headerTextInTable', width: '80px' }
      ],

      // STRING FORMAT
      dObjectFormat: {
        'sinEnviar': 'SIN ENVIAR',
        'sinAlbaran': 'SIN ALBARAN'
      },

      // PEDIDOS

      dNumeroPedido: null,
      dChkPedidosPendientes: false,
      dPedidoItems: null,
      dFiltrosPedidos: [
        { 'tipo': 'P', 'selected': true, 'text': this.$t('pedidos') },
        { 'tipo': 'C', 'selected': true, 'text': this.$t('checkCargos') },
        { 'tipo': 'A', 'selected': true, 'text': this.$t('checkAbonos') },
        { 'tipo': 'S', 'selected': false, 'text': this.$t('checkValido') }
      ],
      dMostrarPedidosDetalle: false,
      dPedidosValue: [],
      dLineasPedido: [],
      dLineasPedidoDetalle: [],
      dTiposPedidos: {
        'P': this.$t('pedido'),
        'C': this.$t('cargo'),
        'A': this.$t('abono')
      },
      dPedidosDetalles: {},
      dPedidos: [],
      dLoadingPED: false,
      dTotalItemsPED: 0,
      dRowsPerPageItemsPED: [10, 15, 30],
      dPaginationPED: { 'sortBy': 'fechaPedido', 'descending': true, 'rowsPerPage': 10 },

      // REPRESENTANTES

      dErroMessageRepresentanteInicialPED: [],
      dRequestRepresentante: { empresa: this.$store.getters.getAutenticacion.empresa, pasivo: 'N' },
      dRequestRepreSec: { empresa: this.$store.getters.getAutenticacion.empresa },
      dSelectedRepre: { codigo: '', subfield: '', nombre: '' },

      // ARTICULOS

      dArticulo: '',
      dObra: '',
      dArticulos: [],
      dArticleFound: '',

      // CLIENTES

      dTelefonoCliente: '',

      dClientInfoDialog: false,
      dShowClient: false,
      dCIFCliente: '',
      dShowClientSearch: false,
      dClientSearchDialog: false,

      dSelectedClient: { cliente: '', nombreCliente: '' },
      dSelectedSucursal: { sucursal: '', nombreSucursal: '' },
      dRequestCliente: { empresa: this.$store.getters.getAutenticacion.empresa },
      dMostrarErrorDescarga: false,
      dMostrarPopupEmailCsv: false,
      dTextoAvisoError: '',
      dEmailDestinoCsv: '',
      dRolCliente: 'CLIENTE',
      dMostrarAviso: false,
      dTextAviso: '',
      dDatosClientes: {
        'nombre': '',
        'codigo': '',
        'direccion': '',
        'telefono': '',
        'CIF': '',
        'email': ''
      },
      dInicialMenu: '',
      dFinalMenu: '',
      dDatosFecha: {
        'inicialMenu': '',
        'inicialString': '',
        'finalString': '',
        'finalMenu': '',
        'minIni': '',
        'minFin': '',
        'finPEDDateString': '',
        'fechasValidas': true
      },

      // INI de las variables del componente Datadec
      dDataClient: {},
      dDataRepre: {},
      dDataSucursal: {},
      dSelectSucursal: { sucursal: '', nombreSucursal: '' },

      // FECHAS
      // Están dentro de las funciones de Watch, por lo tanto no se agrega al objecto de dDatosFecha

      dFechaFinPEDDate: null,
      dFechaInicialDate: null,
      dFechaFinalDate: null,
      // HEADER DOMAIN
      dHeaderDomain: '',
      rules: {
        checkfechas: (value) => {
          if (this.dDatosFecha.inicialString !== null && this.dDatosFecha.finalString !== null && this.dDatosFecha.inicialString !== '' && this.dDatosFecha.finalString !== '') {
            const fechaIniDate = this.$moment(this.dDatosFecha.inicialString, this.dFormatDate.default)
            const fechaFinDate = this.$moment(this.dDatosFecha.finalString, this.dFormatDate.default)
            if (fechaIniDate <= fechaFinDate) {
              this.dDatosFecha.fechasValidas = true
              return true
            } else {
              this.dDatosFecha.fechasValidas = false
              return this.$t('fechaInicialMayorFinal')
            }
          } else {
            this.dDatosFecha.fechasValidas = true
            return true
          }
        }
      }
    }
  },
  watch: {
    dFechaFinPEDDate: function (val, oldVal) {
      // formateo fechas
      if (val !== null) {
        this.dDatosFecha.finPEDDateString = this.$moment(val, this.dFormatDate.years).format(this.dFormatDate.default)
      }
    },
    dPaginationPED: {
      handler(newPage, oldPage) {
        if (this.dContador < 1) {
          if (this.pLimitDate.autoFiltro || localStorage.getItem('TiendaToken') === 'true') {
            this.fIniciarFechas()
            this.dOpenFechaDefault = true
            if (!this.dIsLimpiar) {
              this.fCargarPedidos(this.dPaginationPED.sortBy, this.dPaginationPED.descending, this.dPaginationPED.page, this.dPaginationPED.rowsPerPage, '')
            } else {
              this.dIsLimpiar = false
            }
          }
        } else {
          this.dOpenFechaDefault = false
          if (!this.dIsLimpiar) {
            this.fCargarPedidos(this.dPaginationPED.sortBy, this.dPaginationPED.descending, this.dPaginationPED.page, this.dPaginationPED.rowsPerPage, '')
          } else {
            this.dIsLimpiar = false
          }
        }
        this.dContador++
        if (localStorage.getItem('TiendaToken') === 'true') {
          localStorage.setItem('TiendaToken', 'false')
        }
      },
      deep: true
    },
    dFechaInicialDate: function (val, oldVal) {
      if (val !== null) {
        this.dDatosFecha.inicialString = this.$moment(val, this.dFormatDate.years).format(this.dFormatDate.default)
      }
    },
    dFechaFinalDate: function (val, oldVal) {
      if (val !== null) {
        this.dDatosFecha.finalString = this.$moment(val, this.dFormatDate.years).format(this.dFormatDate.default)
      }
    }
  },
  mounted() {
    this.loadAllOrderWebStatus().then((response) => {
      if (localStorage.getItem('headerDomain') === 'JVISO' || localStorage.getItem('headerDomain') === 'JVISOERP2T1') {
        //Se ha decidido no mostrar el estado de anulado para JVISO, lo quitaremos solo del frontend por si en un futuro se desean visualizar...
        response = response.filter(estado => {
          return estado.id !== 2;
        });
      }
      this.dPedidoItems = response
    })
    this.dContador = 0
    this.fIniciarFechas()
    this.dVisibleBtn = this.$store.getters.getUrlInfo.visibleBtn === 'S'
    this.dVisibleFechaExp = this.$store.getters.getUrlInfo.visibleFecha === 'S'

    // Inicializar dScreenWidth
    this.dScreenWidth = window.innerWidth
    // Agregar listener para actualizar cuando cambie el tamaño de la ventana
    this.fUpdateScreenWidth()
    window.addEventListener('resize', this.fUpdateScreenWidth)
  },
  created() {
    this.dHeaderDomain = localStorage.getItem('headerDomain')
    this.fLimpiaFiltros(true)
    this.fAssignedHeaders()
    this.fIniciarVariables()
    this.fGetZonas()

    this.dInformeComponente = this.pInformeComponente
    this.lastCustomerSearch = null
  },
  methods: {
    fAssignedHeaders() {
      const isChaves = localStorage.getItem('headerDomain') === 'CHAVES' || localStorage.getItem('headerDomain') === 'CHAVESPR';
      const baseHeaders = [
        { text: '', align: 'center', value: 'iconEstado', sortable: false, class: 'px-0', width: '10px', fixed: true },
        { text: '', align: 'left', value: 'sort', sortable: false, class: 'px-0', width: '10px', fixed: true },
        { text: this.$t('cliente'), align: 'left', value: 'clteNombre', sortable: true, class: 'pl-0 headerTextInTable', width: '300px' },
        { text: this.$t('sucursal'), align: 'left', value: 'razonSocial', sortable: true, class: this.dClass, width: '500px' },
        { text: this.$t('tipoPed'), align: 'left', value: 'pedido_cargo_abono', sortable: true, class: this.dClass, width: '100px' },
        { text: this.$t('pedido'), align: 'right', value: 'cpmNumPedido', sortable: true, class: this.dClass, width: '100px' },
        { text: this.$t('fechaAsignada'), align: 'right', value: 'fechaPedido', sortable: true, class: this.dClass, width: '80px' },
        { text: this.$t('pedidoWeb'), align: 'left', value: 'cpmNumPedidoWeb', sortable: true, class: this.dClass, width: '100px' },
        { text: this.$t('obra'), align: 'left', value: 'obra', sortable: true, class: this.dClass, width: '200px' },
        { text: this.$t('suReferencia'), align: 'left', value: isChaves ? 'refLineal' : 'refPedido', sortable: true, class: 'pl-3 pr-2 headerTextInTable', width: '350px' },
        { text: this.$t('estado'), align: 'left', value: 'situacionPedido', sortable: true, class: this.dClass, width: '100px' },
        { text: this.$t('estadoPedido'), align: 'left', value: 'estadoPelikane', sortable: true, class: this.dClass, width: '150px' },
        { text: this.$t('agenciaTte'), align: 'left', value: 'agenciaTransporte', sortable: true, class: this.dClass, width: '100px' }
      ];

      if (isChaves && !this.dVisibleFechaExp) {
        this.dHeadersPED = baseHeaders;
      } else {
        const fechaHeader = isChaves
          ? { text: this.$t('fechaExpedicion'), align: 'right', value: 'fechaIni', sortable: true, class: 'pl-1 pr-3 headerTextInTable', width: '80px' }
          : { text: this.$t('fechaPrevExp'), align: 'right', value: 'fechaRecepPedido', sortable: true, class: 'pl-1 pr-3 headerTextInTable', width: '80px' };
        this.dHeadersPED = [...baseHeaders, fechaHeader];
      }

      this.dPedidosDetalles = {
        dialog: false,
        direccionEnvio: '',
        direccionFacturacion: '',
        emailEnvio: '',
        poblacionEnvio: '',
        poblacionFacturacion: '',
        telefonoEnvio: '',
        telefonoFacturacion: '',
        CIFEnvio: '',
        CIFFacturacion: '',
        agenciaTtte: '',
        clteNombre: '',
        numPedido: '',
        tipoPedido: '',
        estadoPedido: '',
        fechaPedido: '',
        fechaRecep: '',
        [isChaves ? 'referenciaLineal' : 'refPedido']: '',
        razonSocial: '',
        clteID: ''
      };
    },
    fReiniciarVariables() {
      const isChaves = localStorage.getItem('headerDomain') === 'CHAVES' || localStorage.getItem('headerDomain') === 'CHAVESPR';
      const refField = isChaves ? 'referenciaLineal' : 'refPedido';
      Object.assign(this.dPedidosDetalles, {
        numPedido: '',
        tipoPedido: '',
        clteID: '',
        clteNombre: '',
        razonSocial: '',
        [refField]: '',
        direccionEnvio: '',
        poblacionEnvio: '',
        telefonoEnvio: '',
        telefonoFacturacion: '',
        agenciaTtte: '',
        CIFFacturacion: '',
        direccionFacturacion: '',
        poblacionFacturacion: ''
      });
      this.dDatosClientes = {};
    },
    fIniciarVariables() {
      this.dRole = this.pLimitDate.roleUser
      this.fAssignedRole()
      this.dDataClient = {
        'errorMessages': this.dErroMessageRepresentanteInicialPED,
        'label': 'clienteInicial',
        'rowsPerPage': this.rowsPerPage,
        'headers': [
          { text: this.$t('cliente'), align: 'left', value: 'codigo', column: 'cliente' },
          { text: this.$t('nombreCliente'), align: 'left', value: 'nombre', column: 'clienteNombre' }
        ],
        // Se cambia para que haga la llamada a un servicio y no directamente la llamada
        'urlWS': 'lovClte',// '/wscomun/clte/lovClte'
        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': 'cliente', 'nombre': 'nombre' },
        'resultName': 'dataRes',
        'request': this.dRequestCliente,
        'default': { 'codigo': '', 'nombre': '' },
        'disabled': false,
        'required': false,
        'orderByDefault': 'cliente',
        'orderDefault': 'ASC',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': 'seleccionaUnCliente'
      }
      this.dDataSucursal = {
        'errorMessages': [],
        'label': this.$t('sucursal'),
        'rowsPerPage': 10,
        'headers': [
          { text: this.$t('sucursal'), align: 'left', value: 'codigo', column: 'sucursal' },
          { text: this.$t('nombreSucursal'), align: 'left', value: 'nombre', column: 'razonSocial' }
        ],
        // Se cambia para que haga la llamada a un servicio y no directamente la llamada
        'urlWS': 'lovDic',
        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': 'sucursal', 'nombre': 'razonSocial' },
        'resultName': 'dataRes',
        'request': null,
        'default': this.dSelectSucursal,
        'disabled': true,
        'required': true,
        'orderByDefault': 'sucursal',
        'orderDefault': 'sucursal',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': this.$t('seleccionaUnaSucursal'),
        'client': this.dRequestCliente.codigo
      }

      if (this.pLimitDate.roleUser === 'CLIENTE' || this.pLimitDate.roleUser === 'MULTISUCURSAL') {
        this.dDataSucursal.disabled = false
        this.dDataSucursal.request = {
          empresa: this.$store.getters.getAutenticacion.empresa,
          cliente: this.$store.getters.getAutenticacion.cliente
        }
      }

      let isRepre = false
      if (this.dRole === 'REPRESENTANTE') {
        isRepre = true
        this.dRequestRepreSec = {
          empresa: this.$store.getters.getAutenticacion.empresa,
          representante: this.$store.getters.getAutenticacion.representante,
          agente: this.$store.getters.getAutenticacion.agente
        }
      }
      this.dDataRepre = {
        'errorMessages': this.dErroMessageRepresentanteInicialPED,
        'labelMainField': 'codigo',
        'labelSubField': 'agente',
        'label': 'representanteInicial',
        'rowsPerPage': this.rowsPerPage,
        'headers': [
          { text: this.$t('Representante'), align: 'left', value: 'codigo', column: 'representante' },
          { text: this.$t('agente'), align: 'left', value: 'subfield', column: 'agente' },
          { text: this.$t('nombreRepresentante'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        // Se cambia para que haga la llamada a un servicio y no directamente la llamada
        'urlWS': 'lovRep', // /wscomun/rep/lovRep
        'headersSec': [
          { text: this.$t('Representante'), align: 'left', value: 'codigo', column: 'REP_REPRESENTANTE' },
          { text: this.$t('agente'), align: 'left', value: 'subfield', column: 'REP_AGENTE' },
          { text: this.$t('nombreRepresentante'), align: 'left', value: 'nombre', column: 'REP_NOMBRE' }
        ],
        'filtersSec': { 'codigo': 'REP_REPRESENTANTE', 'subfield': 'REP_AGENTE', 'nombre': 'REP_NOMBRE' },
        'defaultSec': { 'codigo': '', 'subfield': '', 'nombre': '' },
        'isSec': isRepre,
        'urlSec': 'getRepres',
        'requestSec': this.dRequestRepreSec,
        'orderByDefaultSec': 'REP_REPRESENTANTE',
        'item': { 'codigo': '', 'subfield': '', 'nombre': '' },
        'request': this.dRequestRepresentante,
        'filters': { 'codigo': 'representante', 'subfield': 'agente', 'nombre': 'nombre' },
        'resultName': 'dataRes',
        'default': this.dSelectedRepre,
        'disabled': false,
        'required': false,
        'title': 'selectRepresentante',
        'isVisibleLoad': true,
        'orderByDefault': 'representante',
        'orderDefault': 'ASC'
      }

      this.dCodTracking = { "codTracking": "", "tipoTracking": "" };
      this.dError = { "code": "", "message": "" };
    },

    fSelectClient(item) {
      if (item && item != null) {
        this.dSelectedClient.cliente = item.codigo
        this.dSelectedClient.clienteNombre = item.nombre
      }

      if (this.dRoleSelect === "SUCURSAL" && this.dSelectClientIni.codigo === undefined) {
        this.fClearClient()
      }

      this.dDataSucursal.client = item.codigo
      this.dDataSucursal.request = {
        empresa: this.$store.getters.getAutenticacion.empresa,
        cliente: item.codigo
      }

      if (item.codigo !== '' && item.codigo !== undefined && this.$refs.TablaDeSucursal !== undefined) {

        this.$refs.TablaDeSucursal.fChangeDisabled(false)
      }
    },
    fClearClient() {
      if (this.$refs.TablaDeSucursal !== undefined) {

        this.$refs.TablaDeSucursal.fChangeDisabled(true)
        this.$refs.TablaDeSucursal.fClear()
      }
      if (this.$refs.TablaDeClient !== undefined) {
        this.$refs.TablaDeClient.fClean()
      }
      this.fClearSucursal()

    },
    fSelectSucursal(item) {
      this.dSelectSucursal.codigo = item.codigo
      this.dSelectSucursal.nombre = item.nombre
      //this.dUsuarioSeleccionado.sucursalClte = item.codigo
    },
    fClearSucursal() {
      this.dDataSucursal.disabled = true
      this.dSelectSucursal = {}
    },
    fSelectRepre(item) {
      if (item && item != null) {
        this.dSelectedRepre.codigo = item.codigo
        this.dSelectedRepre.subfield = item.subfield
        this.dSelectedRepre.nombre = item.nombre
      }
    },
    fClearRepre() {
      this.dSelectedRepre = {}
    },
    fCerrarModal() {
      this.dDialog = false
    },
    fGetLineDeliveryDate(orderLine) {
      return this.fGetDeliveryDate(orderLine.situacionPedido, orderLine.fechaEntrega)
    },
    fOpenClientDialog() {
      this.dClientSearchDialog = true
    },
    fGetDeliveryDate(situacion, fechaEntrega) {
      return (situacion === 0) ? null : fechaEntrega
    },
    fDial: function (number) {
      window.location = 'tel:' + number
    },
    fSendmail: function (address) {
      window.location = 'mailto:' + address
    },
    fCloseSearchClient() {
      this.dClientSearchDialog = false
    },
    fCheckOldDays() {
      return (this.pLimitDate.diasAntiguedad !== null && this.pLimitDate.diasAntiguedad !== undefined &&
        this.pLimitDate.diasAntiguedad > 0 && this.pLimitDate.diasAntiguedad !== '')
    },
    fReturnDate(datePass) {
      const date = { 'dia': '', 'mes': '' }
      date.mes = (datePass.getMonth() < 10) ? this.fPadTo2Digits((datePass.getMonth() + 1)) : (datePass.getMonth() + 1)
      date.dia = (datePass.getDate() < 10) ? this.fPadTo2Digits(datePass.getDate()) : datePass.getDate()
      return date
    },
    fIniciarFechas() {
      if (this.pLimitDate.fechaIniLimit !== '' && this.pLimitDate.fechaIniLimit !== null) {
        this.dDatosFecha.inicialString = this.$moment(this.pLimitDate.fechaIniLimit, this.dFormatDate.years).format(this.dFormatDate.default)
        this.dDatosFecha.minIni = this.$moment(this.pLimitDate.fechaIniLimit, this.dFormatDate.years).format(this.dFormatDate.years)
      } else {
        // Si no hay límite de fecha inicial, calcular retrocediendo diasAntiguedad días desde hoy
        const dateIni = new Date()
        const diasRetroceder = this.fCheckOldDays() ? this.pLimitDate.diasAntiguedad : 30
        dateIni.setDate(dateIni.getDate() - diasRetroceder)

        const monthDay = this.fReturnDate(dateIni)
        this.dDatosFecha.inicialString = monthDay.dia + '/' + this.fPadTo2Digits(monthDay.mes) + '/' + dateIni.getFullYear()
        this.dDatosFecha.inicialMenu = dateIni.getFullYear() + '-' + this.fPadTo2Digits(monthDay.mes) + '-' + monthDay.dia
        this.dDiasAnteriores = diasRetroceder
      }
      if (this.pLimitDate.fechaFinLimit !== '' && this.pLimitDate.fechaFinLimit !== null) {
        this.dDatosFecha.finalString = this.$moment(this.pLimitDate.fechaFinLimit, this.dFormatDate.years).format(this.dFormatDate.default)
        this.dDatosFecha.minFin = this.$moment(this.pLimitDate.fechaFinLimit, this.dFormatDate.years).format(this.dFormatDate.years)
      }
    },
    fPadTo2Digits(num) {
      return num.toString().padStart(2, '0')
    },
    fAssignedInvoice() {
      const numeroFacturas = []
      const facturasObjects = []
      this.dLineasPedidoDetalle.forEach(linea => {
        if (linea.secuenciaFactura === null || linea.secuenciaFactura === 'null' || linea.secuenciaFactura === undefined) {
          if (!numeroFacturas.includes(linea.numeroFactura)) {
            numeroFacturas.push(linea.numeroFactura)
            facturasObjects.push({
              'numFactura': linea.numeroFactura,
              'representante': linea.representante,
              'cliente': linea.cliente,
              'fechaFactura': linea.fechaFactura,
              'serie': linea.serieFactura
            })
          }
        } else {
          if (!numeroFacturas.includes(linea.secuenciaFactura)) {
            numeroFacturas.push(linea.secuenciaFactura)
            facturasObjects.push({
              'numFactura': linea.secuenciaFactura,
              'representante': linea.representante,
              'cliente': linea.cliente,
              'fechaFactura': linea.fechaFactura,
              'serie': linea.serieFactura
            })
          }
        }
      })
      return facturasObjects
    },
    fOpenFacturas(facturas) {
      const ventanaPdf = abrirPestanaEnBlanco()
      let serie
      let payload
      facturas.forEach((factura, index) => {
        payload = {
          tira: this.$store.getters.getAutenticacion.tira,
          empresa: String(this.$store.getters.getAutenticacion.empresa),
          tipoEmpresa: '0',
          pdfSn: 'S',
          rpteIni: String(factura.representante),
          rpteFin: String(factura.representante),
          fechaIni: this.$moment(factura.fechaFactura, 'YYYY/MM/DD').format(this.dFormatDate.default),
          fechaFin: this.$moment(factura.fechaFactura, 'YYYY/MM/DD').format(this.dFormatDate.default),
          clteIni: String(factura.cliente),
          clteFin: String(factura.cliente),
          factFin: String(factura.numFactura),
          factIni: String(factura.numFactura)
        }
        serie = factura.serie
        if (serie !== null && serie !== undefined && serie !== 'null' && serie.length > 0) {
          const series = [{ serie: serie }]
          payload.series = series
        }

        SrvImpresion.getURLFacturas(payload).then(response => {
          if (response.data.statusCode === '200' || response.data.errorCode !== -21001) {
            abrirPdfEnPestanaPreabierta(generarPdf(response.data.report), index === 0 ? ventanaPdf : null)
          } else {
            if (index === 0 && ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
            this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
          }
        })
      })
    },
    fAssignedAlbaranes() {
      const numeroAlbaranes = []
      const albaranesObjects = []
      this.dLineasPedidoDetalle.forEach(linea => {
        if (!numeroAlbaranes.includes(linea.numeroAlbaran)) {
          numeroAlbaranes.push(linea.numeroAlbaran)
          albaranesObjects.push({
            'numAlbaran': linea.numeroAlbaran,
            'ejercicio': linea.numeroEjercicio
          })
        }
      })
      return albaranesObjects
    },
    fOpenAlbaranes(albaranes) {
      const ventanaPdf = abrirPestanaEnBlanco()
      let payload
      albaranes.forEach((factura, index) => {
        payload = {
          tira: this.$store.getters.getAutenticacion.tira,
          empresa: String(this.$store.getters.getAutenticacion.empresa),
          tipoEmpresa: '0',
          pdfSn: 'S',
          ejercicio: factura.ejercicio,
          albaranInicial: factura.numAlbaran,
          albaranFinal: factura.numAlbaran
        }
        SrvImpresion.imprimirAlbaran(payload).then(response => {
          if (response.data.infoMsg.code === '0' || response.data.dataRes.errorCode !== -21001) {
            abrirPdfEnPestanaPreabierta(generarPdf(response.data.dataRes.report), index === 0 ? ventanaPdf : null)
          } else {
            if (index === 0 && ventanaPdf && !ventanaPdf.closed) ventanaPdf.close()
            this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br> ' + response.data.dataRes.errorMsg + '  (' + response.data.dataRes.errorCode + ' ) ')
          }
        })
      })
    },
    fGetCliente(numCliente, empresa) {
      if (!this.dMostrarPedidosDetalle) {
        this.dClientInfoDialog = true
      }
      // limpiamos para nueva consulta
      this.dDatosClientes.nombre = ''
      this.dDatosClientes.codigo = ''
      this.dDatosClientes.direccion = ''
      this.dDatosClientes.telefono = ''
      this.dDatosClientes.CIF = ''
      this.dDatosClientes.email = ''
      const payload = {
        empresa: empresa || this.$store.getters.getAutenticacion.empresa,
        tira: this.$store.getters.getAutenticacion.tira,
        numRows: 10000,
        offset: 1,
        cliente: numCliente
      }
      SrvGeneral.lovClte(payload).then(response => {
        const data = response.data.dataRes[0]
        this.dDatosClientes.nombre = data.nombre
        this.dDatosClientes.codigo = data.cliente
        this.dDatosClientes.direccion = data.direccion
        this.dDatosClientes.telefono = data.telefono
        this.dDatosClientes.CIF = data.cif
        this.dDatosClientes.email = data.correoElectronico
        this.dPedidosDetalles.razonSocial = data.razonSocial
        this.dPedidosDetalles.CIFFacturacion = data.cif
      })
    },
    fGetClienteDetalle(empresa, numCliente, isDialog) {
      if (isDialog) {
        this.dClientInfoDialog = true
      }
      // limpiamos para nueva consulta
      this.dDatosClientes.nombre = ''
      this.dDatosClientes.codigo = ''
      this.dDatosClientes.direccion = ''
      this.dDatosClientes.telefono = ''
      this.dDatosClientes.CIF = ''
      this.dDatosClientes.email = ''

      const payload = {
        empresa: empresa || this.$store.getters.getAutenticacion.empresa,
        tira: this.$store.getters.getAutenticacion.tira,
        numRows: 10000,
        offset: 1,
        cliente: numCliente
      }
      SrvGeneral.lovClte(payload).then(response => {
        const data = response.data.dataRes[0]
        if (data) {
          this.dDatosClientes.nombre = data.nombre
          this.dDatosClientes.codigo = data.cliente
          this.dDatosClientes.direccion = data.direccion
          this.dDatosClientes.telefono = data.telefono
          this.dDatosClientes.CIF = data.cif
          this.dDatosClientes.email = data.correoElectronico
          this.dPedidosDetalles.razonSocial = data.razonSocial
          this.dPedidosDetalles.CIFFacturacion = data.cif
          this.dMostrarPedidosDetalle = true
          setTimeout(() => {
            this.$refs.PedidosDetalles.fRecargarDatos(this.dLineasPedidoDetalle, this.dPedidosDetalles, this.dDatosClientes)
          }, 400)
        }
      })
    },
    fChangeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    fGetZonas() {
      const payload = {
        empresa: this.$store.getters.getAutenticacion.empresa
      }
      SrvGeneral.lovZon(payload).then((response) => {
        this.dZonaItems = response.data.dataRes
      }).catch((error) => {
        console.log(error)
      })
    },
    fExpand(props) {
      this.dLineasPedido = []
      this.fOpenModalGenerico()
      props.expanded = !props.expanded
      if (props.expanded) {
        const promises = []

        this.fGetLineasPedido(props.item.clteCodigo, props.item.cpmNumPedido, props.item.pedido_cargo_abono).then(response => {
          if (this.fRespuestaCorrecta(response)) {
            const lineas = response.data.dataRes
            props.item.lineasPedido = response.data.dataRes
            lineas.forEach(linea => {
              promises.push(this.fGetPelikanePromise(linea, linea))
            })
            Promise.all(promises).then(result => {
              // Lineas de pedido, solamente se hace la opción para el cliente GLICERIO CHAVES
              if (localStorage.getItem('isOnPremise') === 'yes' && (this.dHeaderDomain === 'CHAVES' || this.dHeaderDomain === 'CHAVESPR') && props.item.refLineal !== undefined && props.item.refLineal !== null) {
                result.forEach(linea => {
                  if (props.item.refLineal === linea.referenciaLineal) {
                    this.dLineasPedido.push(linea)
                  }
                })
              } else {
                this.dLineasPedido = result
              }
              this.fCerrarModalGenerico()
            }).catch(error => {
              console.log(error)
              this.fCerrarModalGenerico()
              Promise.reject(error)
            })
          } else {
            this.fCerrarModalGenerico()
            this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b></br>' + this.$t('errorDefaultDesc'))
          }
        }).catch(error => {
          console.log(error)
          this.fCerrarModalGenerico()
        })
      } else {
        this.fCerrarModalGenerico()
      }
    },
    fObtenerUltimoEstado(estadosPelikane) {
      return estadosPelikane.reduce(function (valor1, valor2) {
        return new Date(valor1.fecha + ' ' + valor1.hora) > new Date(valor2.fecha + ' ' + valor2.hora) ? valor1 : valor2
      })
    },
    fGetPedido(detallePedido) {
      this.dLoadingDefault = true;
      this.$refs.PedidosDetalles.fLimpiarDatos();
      this.fReiniciarVariables();
      this.dLineasPedidoDetalle = [];
      this.dPedidosDetalles.muestraFacturaCab = true;
      this.dPedidosDetalles.tieneFactura = false;
      this.dPedidosDetalles.tieneAlbaran = false;
      this.dPedidosDetalles.muestraAlbaranCab = this.dVisibleBtn;
      this.dMostrarPedidosDetalle = true;

      const filtroAlbaran = !(localStorage.getItem('isOnPremise') === 'yes' &&
        (this.dHeaderDomain === 'CHAVES' || this.dHeaderDomain === 'CHAVESPR') &&
        detallePedido.situacionPedido.charAt(0) === '5');

      this.fOpenModalGenerico();

      this.fGetLineasPedido(detallePedido.clteCodigo, detallePedido.cpmNumPedido, detallePedido.pedido_cargo_abono).then(response => {
        const lineas = response.data.dataRes;
        if (localStorage.getItem('isOnPremise') === 'yes' &&
          (this.dHeaderDomain === 'CHAVES' || this.dHeaderDomain === 'CHAVESPR') &&
          detallePedido.refLineal) {
          this.dLineasPedidoDetalle = lineas.filter(linea => linea.referenciaLineal === detallePedido.refLineal);
        } else {
          this.dLineasPedidoDetalle = lineas;
        }

        if (filtroAlbaran && this.dLineasPedidoDetalle.length > 0) {
          this.dLineasPedidoDetalle.forEach(linea => {
            if (linea.numeroAlbaran > 0) {
              this.dPedidosDetalles.tieneAlbaran = true;
            }
            if (linea.numeroFactura > 0) {
              if (this.dRole !== 'SUCURSAL' || this.$store.getters.getAutenticacion.sucursal === linea.sucursalFactura) {
                this.dPedidosDetalles.tieneFactura = true;
              }
            }
          });
        } else {
          this.dPedidosDetalles.muestraAlbaranCab = false;
          this.dPedidosDetalles.muestraFacturaCab = false;
        }

        Object.assign(this.dPedidosDetalles, {
          agenciaTtte: detallePedido.agenciaTransporte,
          clteNombre: detallePedido.clteNombre,
          clteID: detallePedido.clteCodigo,
          numPedido: detallePedido.cpmNumPedido,
          tipoPedido: detallePedido.pedido_cargo_abono,
          estadoPedido: detallePedido.situacionPedido,
          fechaPedido: detallePedido.fechaPedidoFormat,
          fechaRecep: detallePedido.fechaRecepPedido,
          refPedido: detallePedido.refPedido,
          referenciaLineal: detallePedido.refLineal,
          clteEmpresa: detallePedido.clteEmpresa
        });

        this.fGetDatosEnvioFacturacion(detallePedido);

        this.fGetClienteDetalle(detallePedido.clteEmpresa, detallePedido.clteCodigo, false);

        this.fCerrarModalGenerico();
      }).catch(() => {
        this.fCerrarModalGenerico();
      });
    },
    fGetDatosEnvioFacturacion(detallePedido) {
      if (detallePedido.sucursalEnvio === detallePedido.sucursalFacturacion) {
        const payload = {
          cliente: detallePedido.clteCodigo,
          empresa: detallePedido.clteEmpresa || this.$store.getters.getAutenticacion.empresa,
          sucursal: detallePedido.sucursalEnvio,
          tira: this.$store.getters.getAutenticacion.tira
        }
        SrvGeneral.lovDic(payload).then(response => {
          const data = response.data.dataRes[0]
          if (data) {
            this.dPedidosDetalles.direccionEnvio = data.direccionEnvio
            this.dPedidosDetalles.poblacionEnvio = data.poblacionEnvio
            this.dPedidosDetalles.telefonoEnvio = data.telefono
            this.dPedidosDetalles.emailEnvio = data.email
            this.dPedidosDetalles.direccionFacturacion = this.dPedidosDetalles.direccionEnvio
            this.dPedidosDetalles.poblacionFacturacion = this.dPedidosDetalles.poblacionEnvio
            this.dPedidosDetalles.telefonoFacturacion = this.dPedidosDetalles.telefonoEnvio
            this.dPedidosDetalles.emailFacturacion = this.dPedidosDetalles.emailEnvio
          }
        })
      }
      if (detallePedido.sucursalEnvio !== detallePedido.sucursalFacturacion) {
        const request = {
          cliente: detallePedido.clteCodigo,
          empresa: detallePedido.clteEmpresa || this.$store.getters.getAutenticacion.empresa,
          sucursal: detallePedido.sucursalEnvio,
          tira: this.$store.getters.getAutenticacion.tira
        }
        SrvGeneral.lovDic(request).then(response => {
          const data = response.data.dataRes[0]
          if (data !== null) {
            this.dPedidosDetalles.direccionEnvio = data.direccionEnvio
            this.dPedidosDetalles.poblacionEnvio = data.poblacionEnvio
            this.dPedidosDetalles.telefonoEnvio = data.telefono
            this.dPedidosDetalles.emailEnvio = data.email
          } else {
            this.dPedidosDetalles.direccionEnvio = ''
            this.dPedidosDetalles.poblacionEnvio = ''
            this.dPedidosDetalles.telefonoEnvio = ''
            this.dPedidosDetalles.emailEnvio = ''
          }
        })
        const jsonEntrada = {
          cliente: detallePedido.clteCodigo,
          empresa: detallePedido.clteEmpresa || this.$store.getters.getAutenticacion.empresa,
          sucursal: detallePedido.sucursalFacturacion,
          tira: this.$store.getters.getAutenticacion.tira
        }
        SrvGeneral.lovDic(jsonEntrada).then(response => {
          const data = response.data.dataRes[0]
          this.dPedidosDetalles.direccionFacturacion = data.direccionEnvio
          this.dPedidosDetalles.poblacionFacturacion = data.poblacionEnvio
          this.dPedidosDetalles.telefonoFacturacion = data.telefono
          this.dPedidosDetalles.emailFacturacion = data.email
        })
      }
    },
    fGetLineasPedido(codigoCliente, numPedido, tipoPedido) {
      const payload = {
        empresa: this.$store.getters.getAutenticacion.empresa,
        tipoPedido: tipoPedido,
        numeroPedido: numPedido,
        cliente: codigoCliente
      }
      if (this.dRole === 'SUCURSAL') {
        payload.sucursal = this.$store.getters.getAutenticacion.sucursal
      }
      return ServiceRecogidasEntregas.getPedidosAlbaranes(payload);
    },
    fAlert(msg) {
      this.$emit('alert', msg)
    },
    /**
     * Metodo para cerrar la ventana
     */
    fCerrarVentana() {
      this.fLimpiaFiltros(true)
      this.$emit('close')
    },
    /**
     * Metodo de limpieza de los filtros
     */
    fLimpiaFiltros(validacion) {
      if (!validacion) {
        this.dIsLimpiar = true
      }
      this.erroMessageClienteInicialPED = []
      this.erroMessageRepresentanteInicialPED = []

      if (this.dRole !== 'REPRESENTANTE') {
        this.dSelectedRepre = { codigo: '', subfield: '', nombre: '' }
        if (this.$refs.TablaDeRepresentantes) {
          this.$refs.TablaDeRepresentantes.fActualizarItem(this.dSelectedRepre)
        }
      }
      if (this.dRole !== 'CLIENTE') {
        this.dSelectedClient = { nombre: '', cliente: '' }
        if (this.$refs.TablaDeClientes) {
          this.$refs.TablaDeClientes.fActualizarItem(this.dSelectedClient)
        }
        this.dSelectedSucursal = { sucursal: '', nombreSucursal: '' }
        if (this.$refs.TablaDeSucursal) {
          this.$refs.TablaDeSucursal.fActualizarItem(this.dSelectedSucursal)
        }
      }

      this.dChkPresupuesto = false
      this.dChkPedidosPendientes = false

      this.buscandoClienteInicialPED = false
      this.buscandoRepresentanteInicialPED = false

      this.dClientes = []
      this.dPedidos = []

      this.dPaginationPED = { 'sortBy': 'fechaPedido', 'descending': true, 'rowsPerPage': 10, 'page': 1 }
      this.dSuReferencia = ''
      this.dArticulo = ''
      this.dObra = ''
      this.dDias = 30
      this.dTelefonoCliente = ''
      this.dCIFCliente = ''
      this.dPedidosValue = []
      this.dNumeroPedido = ''
      this.dDatosFecha.inicialString = null
      this.dDatosFecha.finalString = null
      this.dFechaInicialDate = null
      this.dFechaFinalDate = null
    },
    fClosePedidosDetalles() {
      this.dMostrarPedidosDetalle = false
    },
    /**
     * valida el resto de reglas
     */
    fBuscarPedidos() {
      this.dSearchCLTE = ''
      this.fCargarPedidos(this.dPaginationPED.sortBy, this.dPaginationPED.descending, this.dPaginationPED.page, this.dPaginationPED.rowsPerPage, '', [])
    },
    fBuildPedidosPayload(sortBy, descending, page, rowsPerPage) {
      this.fAssignedCheck();

      // Normalizar parámetros
      const normalizedSortBy = sortBy || 'fechaPed';
      const normalizedOrder = descending ? 'DESC' : 'ASC';
      const normalizedPage = page || 1;
      const normalizedRowsPerPage = rowsPerPage || this.dPaginationPED.rowsPerPage;
      const offset = this.dPaginationPED.rowsPerPage * (normalizedPage - 1) + 1;

      // Construir payload base
      const jsonEntrada = {
        tira: this.$store.getters.getAutenticacion.tira,
        usuario: this.$store.getters.getAutenticacion.usuario,
        empresa: this.$store.getters.getAutenticacion.empresa,
        codigoEmpresa: this.$store.getters.getAutenticacion.empresa,
        idioma: this.$i18n.locale.toUpperCase(),
        offset,
        numRows: normalizedRowsPerPage,
        orderBy: normalizedSortBy,
        order: normalizedOrder,
        plazoEntregaSuperado: 'N',
        articulo: this.dArticulo || '',
        obra: this.dObra || ''
      };

      this.fAssignedFilters(jsonEntrada);
      this.fAssignedDate(jsonEntrada);

      // Procesar filtros de tipo de pedido
      const tipoPedidoMap = { 'P': 'tipoPedido', 'C': 'tipoCargo', 'A': 'tipoAbono' };
      let filtrosTipoPedidos = false;
      this.dFiltrosPedidos.forEach(obj => {
        if (obj.selected) {
          if (tipoPedidoMap[obj.tipo]) {
            jsonEntrada[tipoPedidoMap[obj.tipo]] = obj.tipo;
            filtrosTipoPedidos = true;
          } else if (obj.tipo === 'S') {
            jsonEntrada.plazoEntregaSuperado = obj.tipo;
          }
        }
      });

      // Procesar estados
      jsonEntrada.listaEstadosFiltrar = this.dPedidosValue.flatMap(estado =>
        this.getFullExpertStatusFromWebStatus(estado).map(e => ({ estado: e }))
      );

      // Agregar sucursal si existe
      if (this.dSelectSucursal && this.dSelectSucursal.codigo) {
        jsonEntrada.sucursal = this.dSelectSucursal.codigo;
      }

      // Configuración para para lrol SUCURSAL
      if (this.dRole === 'SUCURSAL') {
        const auth = this.$store.getters.getAutenticacion;
        jsonEntrada.clienteInicial = auth.cliente;
        jsonEntrada.clienteFinal = auth.cliente;
        jsonEntrada.sucursal = auth.sucursal;
      }

      return { jsonEntrada, filtrosTipoPedidos };
    },
    fCancelarPopupEmailCsv() {
      this.dMostrarPopupEmailCsv = false
    },
    fGetDefaultEmailCsv() {
      const auth = this.$store.getters.getAutenticacion || {}
      return (auth.email || '').trim()
    },
    fIsValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(email)
    },
    fDescargarCsvPedidos() {
      this.dEmailDestinoCsv = this.fGetDefaultEmailCsv()
      this.dMostrarPopupEmailCsv = true
    },
    fConfirmarDescargarCsvPedidos() {
      const emailDestino = (this.dEmailDestinoCsv || '').trim()
      if (!emailDestino || !this.fIsValidEmail(emailDestino)) {
        this.$emit('alert', '<b>Introduce un email valido</b>')
        return
      }

      this.dEmailDestinoCsv = emailDestino
      this.dMostrarPopupEmailCsv = false
      this.fOpenModalGenerico();

      const { jsonEntrada, filtrosTipoPedidos } = this.fBuildPedidosPayload(
        this.dPaginationPED.sortBy,
        this.dPaginationPED.descending,
        this.dPaginationPED.page,
        this.dPaginationPED.rowsPerPage
      );

      if (!this.fCheckFiltrosPendientes()) {
        this.fCerrarModalGenerico();
        this.$emit('alert', `<b>${this.$t('debeIndicarAlMenosUnoFiltro')}</b>`);
        return;
      }

      if (!filtrosTipoPedidos) {
        this.fCerrarModalGenerico();
        this.$emit('alert', `<b>${this.$t('reviseFiltrosBuscar')}</b>`);
        return;
      }
      jsonEntrada.email = this.dEmailDestinoCsv

      ServiceRecogidasEntregas.descargaCsvPedidosAlbaran(jsonEntrada)
        .then(response => {
          if (!this.fRespuestaCorrecta(response)) {
            this.fCerrarModalGenerico();
            this.$emit('alert', `<b>${this.$t('errorDefault')}</b></br>${this.$t('errorDefaultDesc')}`);
            return;
          }
          this.$emit('alert', this.$t('archivoEnviadoEmail', { email: this.dEmailDestinoCsv }))
          this.fCerrarModalGenerico();
        })
        .catch(error => {
          console.log(error);
          this.fCerrarModalGenerico();
          this.$emit('alert', `<b>${this.$t('errorDefault')}</b></br>${this.$t('errorDefaultDesc')}`);
        });
    },
    /*
     * cambia el orden de an columna
     */
    fCambiaOrden(column) {
      this.dPaginationPED.page = 1
      this.dPaginationPED.rowsPerPage = this.rowsPerPage
      if (this.dPaginationPED.sortBy === column) {
        this.dPaginationPED.descending = !this.dPaginationPED.descending
      } else {
        this.dPaginationPED.sortBy = column
        this.dPaginationPED.descending = false
      }
    },
    /*
     * Metodo de carga de usuarios
     */
    fAssignedRole() {
      switch (this.dRole) {
        case 'CLIENTE':
          this.dSelectedClient.codigo = this.$store.getters.getAutenticacion.cliente
          break
        case 'REPRESENTANTE':
          this.dSelectedRepre.codigo = this.$store.getters.getAutenticacion.representante
          this.dSelectedRepre.nombre = this.$store.getters.getAutenticacion.representanteNombre
          this.dSelectedRepre.subfield = this.$store.getters.getAutenticacion.agente
          break
        case 'MULTISUCURSAL':
          this.dSelectedClient.codigo = this.$store.getters.getAutenticacion.cliente
          break
        default:
      }
    },
    fAssignedFilters(jsonEntrada) {
      if ((this.dSelectedClient !== null && this.dSelectedClient.cliente !== undefined && this.dSelectedClient.cliente !== '')) {
        jsonEntrada.clienteInicial = this.dSelectedClient.cliente
        jsonEntrada.clienteFinal = this.dSelectedClient.cliente
      }

      if ((this.dSelectedRepre !== undefined) && (this.dSelectedRepre.codigo !== '') && (this.dSelectedRepre.codigo !== undefined)) {
        jsonEntrada.representanteInicial = this.dSelectedRepre.codigo
        jsonEntrada.representanteFinal = this.dSelectedRepre.codigo
      }

      if (localStorage.getItem('isOnPremise') !== 'yes') {
        if ((this.dSelectedRepre !== undefined) && (this.dSelectedRepre.subfield !== '') && (this.dSelectedRepre.subfield !== undefined)) {
          if ((this.dRole === 'REPRESENTANTE' && this.$store.getters.getAutenticacion.agente !== this.dSelectedRepre.subfield && this.dSelectedRepre.subfield !== 0) || (this.dRole === 'ADMIN' && this.dSelectedRepre.subfield !== 0)) {
            jsonEntrada.agenteInicial = this.dSelectedRepre.subfield
            jsonEntrada.agenteFinal = this.dSelectedRepre.subfield
          }
        }
      }

      jsonEntrada.numeroPedido = (this.dNumeroPedido !== null && this.dNumeroPedido !== undefined && this.dNumeroPedido !== '') ? this.dNumeroPedido : ''
      jsonEntrada.dias = (this.dDias !== '') ? this.dDias : ''
      jsonEntrada.suReferencia = (this.dSuReferencia !== '') ? this.dSuReferencia : ''

      if (this.dZonaCliente && this.dZonaCliente !== null) {
        jsonEntrada.zona = this.dZonaCliente
      }
    },
    fAssignedDate(jsonEntrada) {
      jsonEntrada.fechaInicio = (this.dDatosFecha.inicialString !== null && this.dDatosFecha.inicialString !== '') ? this.dDatosFecha.inicialString : ''
      jsonEntrada.fechaFin = (this.dDatosFecha.finalString !== null && this.dDatosFecha.finalString !== '') ? this.dDatosFecha.finalString : ''

      if (jsonEntrada.fechaInicio === '' && this.dDatosFecha.minIni !== '') {
        jsonEntrada.fechaInicio = this.$moment(this.dDatosFecha.minIni, this.dFormatDate.years).format(this.dFormatDate.default)
      }
      if (jsonEntrada.fechaFin === '' && this.dDatosFecha.minFin !== '') {
        jsonEntrada.fechaFin = this.$moment(this.dDatosFecha.minFin, this.dFormatDate.years).format(this.dFormatDate.default)
      }
      if (jsonEntrada.fechaInicio !== '' && jsonEntrada.fechaFin !== '') {
        jsonEntrada.numeroAnyosAntiguedadPedidos = '0'
      }
    },
    fAssignedCheck() {
      switch (this.dRole) {
        case 'CLIENTE':
          this.dSelectedClient.cliente = this.$store.getters.getAutenticacion.cliente
          break
        case 'REPRESENTANTE':
          if (this.dSelectedRepre.codigo === undefined || this.dSelectedRepre.codigo === null || this.dSelectedRepre.codigo === '') {
            this.dSelectedRepre = {
              codigo: this.$store.getters.getAutenticacion.representante,
              nombre: this.$store.getters.getAutenticacion.representanteNombre,
              subfield: this.$store.getters.getAutenticacion.agente
            }
          }
          break
        default:
      }
    },
    /*
     * Metodo de carga de usuarios
     */
    fCargarPedidos(sortBy, descending, page, rowsPerPage, search) {
      this.dLineasPedido = [];
      this.fOpenModalGenerico();
      const { jsonEntrada, filtrosTipoPedidos } = this.fBuildPedidosPayload(sortBy, descending, page, rowsPerPage);

      // Validar y cargar pedidos
      if (!this.fCheckFiltrosPendientes()) {
        this.fCerrarModalGenerico();
        this.$emit('alert', `<b>${this.$t('debeIndicarAlMenosUnoFiltro')}</b>`);
        return;
      }
      if (!filtrosTipoPedidos) {
        this.fCerrarModalGenerico();
        this.$emit('alert', `<b>${this.$t('reviseFiltrosBuscar')}</b>`);
        return;
      }

      this.dPedidos = [];
      ServiceRecogidasEntregas.getPedidosAlbaranesCab(jsonEntrada)
        .then(response => {
          if (!this.fRespuestaCorrecta(response)) {
            this.fCerrarModalGenerico();
            return;
          }

          const pedidos = response.data.dataRes.map(pedido => {
            pedido.fechaPedidoFormat = this.formatDate(pedido.fechaPedido);
            if (pedido.fechaRecepPedido) {
              pedido.fechaRecepPedido = this.formatDate(pedido.fechaRecepPedido);
            }

            // Inicializar mostrarBtn a false por defecto
            pedido.mostrarBtn = false;

            // Aplicar la lógica de mostrarBtn basada en los campos del WS de cabecera
            // Esta lógica replica la que había en fGetLineasAlbaran pero adaptada a cabecera
            if (pedido.estadoHUB && pedido.estadoHUB !== null) {
              if (pedido.numeroEjercicio != null &&
                pedido.numeroAlbaran != null &&
                pedido.numeroAlbaran > 0 &&
                pedido.estadoHUB !== this.dObjectFormat.sinEnviar &&
                pedido.estadoHUB !== this.dObjectFormat.sinAlbaran &&
                pedido.estadoHUB !== '') {
                pedido.mostrarBtn = true;
              }
            }

            // Asignar refLineal desde suReferencia (usado en dominio CHAVES)
            pedido.refLineal = pedido.suReferencia;

            // Asignar estadoPelikane (usado para ordenación)
            pedido.estadoPelikane = pedido.situacionPedido || '';

            return pedido;
          });

          this.dPedidos = pedidos;
          this.dTotalItemsPED = response.data.numReg;
          this.dNumValidacionesValue = 0;

          this.fCerrarModalGenerico();
        })
        .catch(error => {
          console.log(error);
          this.fCerrarModalGenerico();
          this.$emit('alert', `<b>${this.$t('errorDefault')}</b></br>${this.$t('errorDefaultDesc')}`);
        });
    },
    fGetLineasAlbaran(pedido) {
      return this.fGetLineasPedido(pedido.clteCodigo, pedido.cpmNumPedido, pedido.pedido_cargo_abono, pedido.clteEmpresa).then(response => {
        if (this.fRespuestaCorrecta(response)) {
          const lineaPedidos = response.data.dataRes
          if (response.data.dataRes.length > 0) {
            let numAlbaran = lineaPedidos[0].numeroAlbaran
            const total = lineaPedidos.length
            let totalAlbaranesIguales = 0
            if (lineaPedidos[0].estadoHUB && lineaPedidos[0].estadoHUB !== null) {
              lineaPedidos.forEach(linea => {
                if (linea.numeroAlbaran !== undefined && linea.numeroAlbaran !== null && linea.numeroAlbaran > 0) {
                  if (numAlbaran === linea.numeroAlbaran) {
                    totalAlbaranesIguales++
                  }
                }
                numAlbaran = linea.numeroAlbaran
              })
              console.log(
                'totalAlbaranesIguales:', totalAlbaranesIguales,
                'total:', total,
                'lineaPedidos[0].numeroEjercicio:', lineaPedidos[0].numeroEjercicio,
                'lineaPedidos[0].numeroAlbaran:', lineaPedidos[0].numeroAlbaran,
                'lineaPedidos[0].estadoHUB:', lineaPedidos[0].estadoHUB,
                'this.dObjectFormat.sinEnviar:', this.dObjectFormat.sinEnviar,
                'this.dObjectFormat.sinAlbaran:', this.dObjectFormat.sinAlbaran
              );
              if (totalAlbaranesIguales === total && lineaPedidos[0].numeroEjercicio != null &&
                lineaPedidos[0].numeroAlbaran != null && lineaPedidos[0].estadoHUB !== this.dObjectFormat.sinEnviar &&
                lineaPedidos[0].estadoHUB !== this.dObjectFormat.sinAlbaran && lineaPedidos[0].estadoHUB !== '') {
                pedido.mostrarBtn = true
              }
            }
          }
          return pedido
        } else {
          return pedido
        }
      }).catch(error => {
        return Promise.reject(error)
      })
    },
    fGetLineasPromise(pedido) {
      return this.fGetLineasPedido(pedido.clteCodigo, pedido.cpmNumPedido, pedido.pedido_cargo_abono, pedido.clteEmpresa).then(response => {
        if (this.fRespuestaCorrecta(response)) {
          const lineaPedidos = response.data.dataRes
          if (lineaPedidos[0]) {
            let numAlbaran = lineaPedidos[0].numeroAlbaran
            const total = lineaPedidos.length
            let totalAlbaranesIguales = 0
            if (lineaPedidos[0].estadoHUB && lineaPedidos[0].estadoHUB !== null) {
              lineaPedidos.forEach(linea => {
                if (linea.numeroEjercicio != null && linea.numeroAlbaran != null) {
                  if (numAlbaran === linea.numeroAlbaran) {
                    totalAlbaranesIguales++
                  }
                  numAlbaran = linea.numeroAlbaran
                }
              })
              if (totalAlbaranesIguales === total && lineaPedidos[0].numeroEjercicio != null &&
                lineaPedidos[0].numeroAlbaran != null && lineaPedidos[0].estadoHUB !== this.dObjectFormat.sinEnviar &&
                lineaPedidos[0].estadoHUB !== this.dObjectFormat.sinAlbaran && lineaPedidos[0].estadoHUB !== '') {
                return this.fGetPelikanePromise(pedido, lineaPedidos[0]).then(result => {
                  return result
                })
              }
            }
          }
          return pedido
        } else {
          return pedido
        }
      })
    },
    fGetPelikanePromise(pedido, lineaPedido) {
      this.dError = { "code": "", "message": "" };
      if (lineaPedido.numeroEjercicio != null && lineaPedido.numeroAlbaran != null && lineaPedido.estadoHUB !== this.dObjectFormat.sinEnviar &&
        lineaPedido.estadoHUB !== this.dObjectFormat.sinAlbaran && lineaPedido.estadoHUB !== '') {
        const payload = {
          tira: JSON.parse(localStorage.getItem('datos-autenticacion')).tira,
          help: 'N',
          albaran: [
            {
              empresa: lineaPedido.empresa,
              tipoEmpresa: '0',
              ejercicio: lineaPedido.numeroEjercicio,
              numeroAlbaran: lineaPedido.numeroAlbaran
            }
          ]
        }
        return ServicePelikane.obtenerTraking(payload).then((response) => {
          if (response.statusCode === '200' && response.result === 'ok' && response.dataRes.result !== undefined) {
            let respuesta = [];
            if (response.dataRes.result.tracking) {
              respuesta = response.dataRes.result.tracking.filter(linea => linea.albaran === lineaPedido.numeroAlbaran)
              pedido.ultimoEstado = this.fObtenerUltimoEstado(respuesta).estado
            }
            pedido.estadosPelikane = respuesta
            pedido.mostrar = true
            this.dCodTracking = { "codTracking": response.dataRes.result.codTracking, "tipoTracking": response.dataRes.result.tipoTracking };
            if (response.dataRes.result.errorMsg) {
              this.dError = { "code": response.dataRes.result.errorMsg.code, "message": response.dataRes.result.errorMsg.message };
            }

            const payload = {
              tira: JSON.parse(localStorage.getItem('datos-autenticacion')).tira,
              help: 'N',
              albaran: [
                {
                  empresa: lineaPedido.empresa,
                  tipoEmpresa: '0',
                  ejercicio: lineaPedido.numeroEjercicio,
                  numeroAlbaran: lineaPedido.numeroAlbaran
                }
              ]
            }
            if (respuesta.length > 0) {
              ServicePelikane.obtenerUrlTracking(payload).then(response => {
                this.dUrlTracking = response.dataRes.result
              })
            }
          }
          else {
            pedido.estadosPelikane = []
            this.dError = {
              "code": response.statusCode || response.status || '500',
              "message": (response.errorMsg && response.errorMsg.message) || this.$t('errorMssgTracking')
            };
            this.$emit('alert', (response.errorMsg && response.errorMsg.message) || `<b>${this.$t('errorDefault')}</b><br>${this.$t('errorDefaultDesc')}`)
          }
          return pedido
        })
      } else {
        return pedido
      }
    },
    /**
     * comprueba si falta recibir información de algun filtro
     */
    fCheckFiltrosPendientes() {
      let returnValue = true
      if (this.dRole === 'CLIENTE') {
        this.dSelectedClient.cliente = this.$store.getters.getAutenticacion.cliente
      } else if (this.dRole === 'SUCURSAL') {
        this.dSelectedClient.cliente = this.$store.getters.getAutenticacion.cliente
        this.dSelectedSucursal.sucursal = this.$store.getters.getAutenticacion.sucursal
      } else if (this.dRole === 'MULTISUCURSAL') {
        this.dSelectedClient.cliente = this.$store.getters.getAutenticacion.cliente
      } else {
        // Para el resto de roles, debe indicarse al menos uno de:
        // fecha inicial, código de representante o número de pedido
        if (!(
          this.fNotEmpty(this.dDatosFecha.inicialString) ||
          this.fNotEmpty(this.dSelectedRepre.codigo) ||
          this.fNotEmpty(this.dNumeroPedido)
        )) {
          returnValue = false
        }
      }
      return returnValue;
    },
    fNotEmpty(value) {
      let returnValue = false
      if (value !== undefined && value !== null && value !== '') {
        returnValue = true
      }
      return returnValue;
    },
    /*
     * Evento que ejecuta el dialogo del cliente
     */
    fSeleccionaCliente(props) {
      this.dSelectedClient = { 'cliente': props.item.cliente, 'clienteNombre': props.item.nombre }
      this.$refs.TablaDeClientes.fActualizarItem({ 'codigo': props.item.cliente, 'nombre': props.item.nombre })
      if (!this.dShowFilters) {
        this.fCargarPedidos(this.dPaginationPED.sortBy, this.dPaginationPED.descending, this.dPaginationPED.page, this.dPaginationPED.rowsPerPage, '')
      }
      this.dClientSearchDialog = false
    },
    fComprobarFechaEntrega(fecha, estado) {
      if (this.dRole === 'ADMIN' || this.dRole === 'REPRESENTANTE') {
        const estadoLinea = this.getStatusWebCode(estado)
        const estados = this.loadAllOrderWebStatusSync()
        const fechaActual = new Date()
        fechaActual.setHours(0, 0, 0, 0)
        const fechaPasada = new Date(fecha)
        fechaPasada.setHours(0, 0, 0, 0)
        return (fechaActual > fechaPasada && this.fCheckEstados(estados, estadoLinea)) ? 'expirateDate' : ''
      } else {
        return ''
      }
    },
    fRestDate(fecha, estado) {
      const estadoLinea = this.getStatusWebCode(estado)
      const estados = this.loadAllOrderWebStatusSync()
      const fechaActual = new Date()
      fechaActual.setHours(0, 0, 0, 0)
      const fechaPasada = new Date(fecha)
      fechaPasada.setHours(0, 0, 0, 0)
      if (fechaActual > fechaPasada && this.fCheckEstados(estados, estadoLinea)) {
        const dateInTime = fechaActual.getTime() - fechaPasada.getTime()
        const diasRestantes = dateInTime / (1000 * 3600 * 24)
        return 'Retraso de ' + diasRestantes + ' días.'
      } else {
        const dia = (fechaPasada.getDate() < 10) ? '0' + fechaPasada.getDate() : fechaPasada.getDate()
        const mes = ((fechaPasada.getMonth() + 1) < 10) ? '0' + (fechaPasada.getMonth() + 1) : (fechaPasada.getMonth() + 1)
        return dia + '/' + mes + '/' + fechaPasada.getFullYear()
      }
    },
    fCheckEstados(estados, estadoLinea) {
      let returnValue = true
      if (estadoLinea === estados.length) {
        returnValue = false
      }
      return returnValue;
    },
    fDescargarFacturaExcel() {
      let factura
      let serieFactura
      let secuenciaFactura

      if (this.dLineasPedidoDetalle[0].numeroFactura !== null && factura && factura !== null) {
        serieFactura = String(factura.numped.substring(0, factura.numped.length - 6))
        secuenciaFactura = Number(factura.numped.substr(factura.numped.length - 6))
      }

      const payload = {
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: String(this.$store.getters.getAutenticacion.empresa),
        tipoEmpresa: '0',
        pdfSn: 'S',
        help: 'N',
        numeroFactura: this.dLineasPedidoDetalle[0].numeroFactura,
        serieFactura: serieFactura,
        secuenciaFactura: secuenciaFactura,
        cliente: String(this.dLineasPedidoDetalle[0].cliente),
        ejercicio: this.dLineasPedidoDetalle[0].numeroEjercicio
      }

      SrvImpresion.imprimirFacturaCSV(payload).then(response => {
        if (response.data.statusCode === '200') {
          const csvContent = atob(response.data.dataRes.File)
          this.downloadCSV(csvContent, this.dLineasPedidoDetalle[0].numeroFactura)
        } else {
          this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
      })
    },
    downloadCSV(csv, filename) {
      // CSV file
      var uint8 = new Uint8Array(csv.length)
      for (var i = 0; i < uint8.length; i++) {
        uint8[i] = csv.charCodeAt(i)
      }
      const csvFile = new Blob([uint8], {
        encoding: 'UTF-16',
        type: 'text/csv;charset=UTF-16'
      })
      // Download link
      const downloadLink = document.createElement('a')
      // File name
      downloadLink.download = filename + '.csv'
      // Create a link to the file
      downloadLink.href = window.URL.createObjectURL(csvFile)
      // Hide download link
      downloadLink.style.display = 'none'
      // Add the link to DOM
      document.body.appendChild(downloadLink)
      // Click download link
      downloadLink.click()
    },
    fCerrarModalGenerico() {
      if (this.dContador > 0 && !this.dOpenFechaDefault) {
        this.dLoadingPED = false
      } else {
        this.dLoadingDefault = false
        this.dOpenFechaDefault = false
      }
    },
    fOpenModalGenerico() {
      if (this.dContador > 0) {
        this.dLoadingPED = true
      } else {
        this.dLoadingDefault = true
        this.dOpenFechaDefault = true
      }
    },
    fGetColor(estado) {
      switch (estado) {
        case 'NoRetenido':
          return 'green'
        case 'Retenido':
          return 'red'
        case 'ParcialmenteRetenido':
          return 'orange'
        default:
          return 'red'
      }
    },
    fGetDenominacionColor(estado) {
      switch (estado) {
        case 'NoRetenido':
          return this.$t('noRetenido')
        case 'Retenido':
          return this.$t('retenido')
        case 'ParcialmenteRetenido':
          return this.$t('parcialmenteRetenido')
        default:
          return this.$t('retenido')
      }
    },
    fGetColorLinea(estado) {
      return (estado > 0) ? 'green' : 'red'
    },
    fIniVars(counter) {
      if (this.chkPresupuesto) {
        counter++;
      }
      if (this.chkPedidosPendientes) {
        counter++;
      }
      if (this.chkServidos) {
        counter++;
      }
      if (this.dSearchCLTE) {
        counter++;
      }
      if (this.dSelectedClient && this.dSelectedClient.cliente) {
        counter++;
      }
      if (this.dSuReferencia) {
        counter++;
      }
      if (this.dArticulo) {
        counter++;
      }
      if (this.dDias !== 30) {
        counter++;
      }
      if (this.dTelefonoCliente) {
        counter++;
      }
      if (this.dCIFCliente) {
        counter++;
      }
      if (Array.isArray(this.dPedidosValue) && this.dPedidosValue.length > 0) {
        counter++;
      }
      if (this.dNumeroPedido) {
        counter++;
      }
      if (this.dObra) {
        counter++;
      }
    },
    fFiltroAdmin() {
      const counter = 0
      if (this.dRole === 'ADMIN') {
        if ((this.dSelectedClient.codigo !== '' && this.dSelectedClient.codigo !== null) || (this.dSelectedRepre.codigo !== '' && this.dSelectedRepre.codigo !== null)) {
          return true
        } else {
          this.fIniVars(counter)
          return (counter > 1)
        }
      } else {
        return false
      }
    },
    fComprobacionRepresentante() {
      let returnValue = true;
      if (this.dRole === 'CLIENTE' || this.dRole === 'SUCURSAL' || this.dRole === 'MULTISUCURSAL') {
        returnValue = false
      }
      return returnValue;
    },
    fOpenModalEstados(pedido, tipo) {
      this.dLoadingPED = true;
      this.dBultosPelikane = [];
      this.dEstadosPelikane = [];
      switch (tipo) {
        case 'pedido':
          this.fGetLineasPromise(pedido).then(result => {
            this.dLoadingPED = false
            if (result.estadosPelikane) {
              this.dEstadosPelikane = result.estadosPelikane.reverse()
              this.dBultosPelikane = [...new Set(this.dEstadosPelikane.map(item => item.numBulto))].sort();
              this.dUrlTracking = result.urlTracking
              this.dDialog = true
            } else {
              this.dEstadosPelikane = []
            }
          })
          break
        case 'linea':
          this.fGetPelikanePromise(pedido, pedido).then(result => {
            this.dEstadosPelikane = result.estadosPelikane.reverse()
            this.dBultosPelikane = [...new Set(this.dEstadosPelikane.map(item => item.numBulto))].sort();
            this.dLoadingPED = false
            this.dDialog = true
          })
          break
        default:
          this.dLoadingPED = false
      }
    },
    fUpdateScreenWidth() {
      this.dScreenWidth = window.innerWidth
    }
  },
  beforeDestroy() {
    // Limpiar el listener cuando se destruya el componente
    window.removeEventListener('resize', this.fUpdateScreenWidth)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Informes/Pedidos/ShpFiltroReportEstadoPedidos.vue